module.exports = __webpack_public_path__ + "img/icon-premium.e278f2e4.svg";